import { render, staticRenderFns } from "./sluserteam.vue?vue&type=template&id=321d4f91&"
import script from "./sluserteam.vue?vue&type=script&lang=js&"
export * from "./sluserteam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports